import { Middleware } from '@nuxt/types'

import { isInitialized } from '~/utils/isInitialized'
import { isSitecoreRequest } from '~/utils/isSitecoreRequest'

const initializer: Middleware = async ({ store, req, error }) => {
  const { state, getters, dispatch } = store

  const isAuthUser = state.oauth.accessToken && getters.currentUser && !getters.currentUser.membership.nonMemberAccount

  // Validate we have already initialized data
  if (isSitecoreRequest(req) || isInitialized(isAuthUser, store)) {
    return
  }

  // Should get here ONCE per user
  try {
    await Promise.all([
      dispatch('venues/fetchVenues', { include: ['house', 'hotel'] }),
      ...(
        isAuthUser
        ? [
          dispatch('events/categories/fetchEventCategories'),
          dispatch('content/categories/fetchContentCategories'),
          dispatch('notifications/fetchNotifications')
        ]
        : []
      )
    ])

    if (!isInitialized(isAuthUser, store)) {
      throw new Error('Cannot start application, one or more bootstrap api calls failed')
    }

    store.commit('initializeApp')
  } catch (e) {
    return error(e)
  }
}

export default initializer
